<template>
    <div>
        <div class="category-item"
            v-for="(category, k) in categories" :key="k"
            @click="clickCategory(category)">
             <div class="category-item-wrapper">
                <div class="img"><img :src="category.image_url" class="card-img-top" /></div>
                <div class="category-item">
                    <strong class="ellipsis mb-3">{{category.name}}</strong>
                    <p class="conditon-text" v-html="category.detail"></p>
                </div>
            </div>
            <div class="border-item"> <img src="../../../assets/icon/line-2@3x.png"/> </div>
        </div>
    </div>
</template>
<script>
//base
import Account from "@/helper/AccountHelper.js";
//service
import BzbsCategory from "@/service/BzbsCategory.js";

export default {
    name: 'CategoryList',
    components: {
    },
    props: {
        locale: Number,
        categoryConfig: Object,
        busEvent: Object
    },
    data: function () {
        return {
            currentTab: '',

            categories: [],
            isHaveCategory: false,
            isLoaded: false,
        };
    },mounted: function () {
        this.busEvent.$on("switchLang", this.switchLang);
    },
    created: function () {
        this.initialCategory();
    },
    methods: {
        clickCategory: function (category) {
            console.log(category)
            var path = '/campaignservice/' + category.list_config + "/"+category.name+"/"+category.id;
            this.$router.push(path);
            // this.$emit('changeCategory', category);
        },
        initialCategory: function () {
            var categoryParam = this.categoryConfig
                .getParams();

            var token = Account.getToken();
            BzbsCategory.apiGetCategory(token, categoryParam)
                .then((categories) => {
                    for (var category of categories) {
                        this.categories.push(category);
                    }

                    this.isLoaded = true;
                    this.isHaveCategory = this.categories.length > 0
                        ? true
                        : false;
                    console.log(this.categories)
                    //this.clickCategory(this.categories[0]);
                }).catch((error) => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    console.log(error);
                });
        },
        switchLang: function() {
            this.categories = [];
            this.initialCategory();
        },
    }
}
</script>
<style lang="scss" scoped>

@import '@/style/base/base.scss';
.category-item {

    .category-item-wrapper {
        @extend %display-flex-nowrap;

        .img {
            width: 40%;
        }
        .category-item {
            width: 60%;
            padding: 10px;
        }
    }
    .border-item {

        img {
            width: 100%;
        }
    }
}

</style>
